export default __webpack_public_path__ + "static/media/slider2.135d6db1.png";